import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import "./PresaleDetailModal.scss";

const SALE_STATUS_LABELS = {
  0: "Programada",
  1: "En preparación",
  2: "Lista para entregar",
  3: "Entregada",
  4: "Cancelada",
};

const formatPrice = (value) =>
  value != null ? `$ ${(value / 100).toLocaleString("es-CO")}` : "—";

const formatUTCTimeTo12h = (timeStr) => {
  if (!timeStr) return "—";
  const [hours, minutes] = timeStr.split(":");
  const date = new Date();
  date.setUTCHours(parseInt(hours), parseInt(minutes), 0, 0);
  return date.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true });
};

const PresaleDetailModal = ({ presale, onClose }) => {
  if (!presale) return null;

  const statusLabel =
    SALE_STATUS_LABELS[presale.sale_information?.sale_status] ??
    presale.sale_information?.sale_status;

  const salePoint = presale.organization?.sale_point_type?.sale_point?.name;
  const schedule = presale.organization?.sale_point_type?.sale_point?.sale_point_schedule;
  const horario = schedule
    ? `${formatUTCTimeTo12h(schedule.opens_at)} - ${formatUTCTimeTo12h(schedule.closes_at)}`
    : "—";
  const date = presale.datetime?.split("T")[0]?.split(" ")[0];

  return (
    <Dialog open={!!presale} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle className="presale-modal-title">
        {presale.customer?.name}
      </DialogTitle>

      <DialogContent dividers>
        <div className="presale-modal-section">
          <div className="presale-modal-row">
            <span className="presale-modal-label">ID</span>
            <span className="presale-modal-value">{presale.id}</span>
          </div>
          <div className="presale-modal-row">
            <span className="presale-modal-label">Pagado por</span>
            <span className="presale-modal-value">{presale.payer_name ?? "—"}</span>
          </div>
          <div className="presale-modal-row">
            <span className="presale-modal-label">Estado</span>
            <span className="presale-modal-value">{statusLabel}</span>
          </div>
          <div className="presale-modal-row">
            <span className="presale-modal-label">Punto de venta</span>
            <span className="presale-modal-value">{salePoint}</span>
          </div>
          <div className="presale-modal-row">
            <span className="presale-modal-label">Horario</span>
            <span className="presale-modal-value">{horario}</span>
          </div>
          <div className="presale-modal-row">
            <span className="presale-modal-label">Fecha</span>
            <span className="presale-modal-value">{date}</span>
          </div>
          <div className="presale-modal-row">
            <span className="presale-modal-label">Valor total</span>
            <span className="presale-modal-value presale-modal-value--highlight">
              {formatPrice(presale.transaction_value)}
            </span>
          </div>
        </div>

        <Divider className="presale-modal-divider" />

        <div className="presale-modal-products-title">Productos</div>
        <div className="presale-modal-products">
          <div className="presale-modal-product-header">
            <span>Producto</span>
            <span>Precio unit.</span>
            <span>Total</span>
          </div>
          {presale.products?.map((prod, i) => (
            <div key={i} className="presale-modal-product-row">
              <span className="presale-modal-product-name">
                {prod.quantity} x {prod.name}
              </span>
              <span className="presale-modal-product-price">
                {formatPrice(prod.sell_price)}
              </span>
              <span className="presale-modal-product-price">
                {formatPrice(prod.sell_price != null ? prod.sell_price * prod.quantity : null)}
              </span>
            </div>
          ))}
        </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} style={{ color: "#01A532" }}>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PresaleDetailModal;
